namespace GeniuzPOS.Inventory {
    export class IcStockApproveDisassembleDtColumns {
        static columnsKey = 'Inventory.IcStockApproveDisassembleDt';
    }
}
